import $ from "jquery";

const clp = {
    methods: {
    chliProductLogoClickHandler : function () {
               $(".right-logo").not(".variation-2").on('click', function(){
                  let pageSection = "Header";
                  var obj = clp.methods.dataLayerObj(pageSection);
                  createDataLayer('ProductLogoClick', obj);
               });
            },

    chliLogoClickHandler : function () {
                   $(".left-logo").on('click', function(){
                      let pageSection = "Header";
                      var obj = clp.methods.dataLayerObj(pageSection);
                      createDataLayer('LogoClick', obj);
                   });
                },

    chliButtonClickHandler : function() {

        $(".right-logo.variation-2 a").on('click',function (e){
           let text = e.currentTarget.innerText.replace(/\n/g, '').trim();
           let href = $(this).attr('href');
           var obj = clp.methods.dataLayerObj('Header',text);
           if(!href.includes('.pdf')){
             createDataLayer('ButtonClick',obj);
           } else {
             createDataLayer('Download_Product',obj);
           }
        });
    },

        dataLayerObj : function(el,text) {
            var obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : text ? text : "",
                'pageSection' : el?el:"",
                'planOption' : "",
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-clp-template' ? "Campaign":"Other page",
                'productCategory' : document.getElementById('productCategoryName') ? document.getElementById('productCategoryName').value : "",
                'productName' : document.getElementById('productPlanName') ? document.getElementById('productPlanName').value : "",
                'question' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'bannerName' : "",
                'bannerType' : "",
                'leadForm' : "",
            };
            return obj;
        },

    }
};

if ($(".headerCLP").length > 0) {
    // "Landed" is now fired centrally by common/js/landed-event.js so it
    // happens on every page (including CLP pages without a chli-base
    // header). Removed the previous createDataLayer("Landed", obj) call
    // here to avoid double-pushing on CLP pages.
}

$(document).ready(function () {
clp.methods.chliLogoClickHandler();
clp.methods.chliProductLogoClickHandler();
clp.methods.chliButtonClickHandler();
});
